import { Link } from 'react-router-dom'

import { useAuth } from '@/features/auth/auth-context'
import { Banner } from '@/shared/components/ui/banner'

export function BlockedBanner() {
  const { user } = useAuth()

  if (user?.organization_blocked !== true) {
    return null
  }

  // Ссылка внутри текста, а не в actions: actions не переносятся (shrink-0)
  // и на узком экране давали бы горизонтальный скролл. role="alert" даёт сам Banner для tone="danger".
  return (
    <Banner className="rounded-none border-x-0 border-t-0" tone="danger">
      Аккаунт заблокирован: ИИ-менеджер не отвечает вашим клиентам ни в одном канале. Чтобы
      возобновить работу, оплатите счёт или свяжитесь с поддержкой.{' '}
      <Link className="whitespace-nowrap font-medium underline" to="/billing">
        Перейти к оплате
      </Link>
    </Banner>
  )
}
